module.exports = __webpack_public_path__ + "static/media/responsive-speed.79e932ea.png";